import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/button_setting.png'


const _withScopeId = n => (_pushScopeId("data-v-2bddfbfb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  id: "settings-button",
  class: "hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-opacity-50"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Settings",
    class: "w-6 h-6"
  })
], -1))
const _hoisted_3 = { class: "text-center mt-8 mb-4" }
const _hoisted_4 = ["src"]

import { onMounted } from "vue";


import { useImagePath } from '@/services/LocalizeService';
import SessionService, { MenuType } from "@/services/SessionService";
import WordSearchBox from "@/components/WordSearchBox.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'DictionaryView',
  setup(__props) {


const { getImagePath } = useImagePath();



onMounted(() => {
  SessionService.SetNowMenuType(MenuType.dictionary);
});



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/setting",
      class: "flex flex-col right-4 space-y-2 text-gray-600 hover:text-green-600"
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("header", _hoisted_3, [
      _createElementVNode("img", {
        src: _unref(getImagePath)('home_logo.png'),
        alt: "Root Dictionary Logo",
        class: "mx-auto"
      }, null, 8, _hoisted_4)
    ]),
    _createVNode(WordSearchBox)
  ]))
}
}

})